import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=24b19d86&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
import style0 from "./Hero.vue?vue&type=style&index=0&id=24b19d86&prod&lang=scss&scoped=true"
import style1 from "./Hero.vue?vue&type=style&index=1&id=24b19d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b19d86",
  null
  
)

export default component.exports